/**
 * Asset and lease financial-control ids (ALC-4607, domain shell ALC-4608), in catalog order. Only
 * the AT domain edits this file (the AP, AR and TR lists live in `ap.ts`, `ar.ts` and `tr.ts`).
 *
 * AT01 acquisition classification and intangible projects, AT02 availability, useful life and
 * depreciation start, AT03 due depreciation and register-to-ledger, AT04 disposals, transfers and
 * write-offs, AT05 monthly impairment-indicator review, AT06 lease treatment versus the book, AT07
 * fixed-asset PIS/COFINS credit reconciliation.
 */
export const AT_FINANCIAL_CONTROL_IDS = [
  'AT01',
  'AT02',
  'AT03',
  'AT04',
  'AT05',
  'AT06',
  'AT07',
] as const;
